export const ACTIVITY_LOG_KEEP_GET_TITLES = [
  "Get Public Login of a provider",
  "Get Portal Login of a user",
  "Get workflow credentials",
];

export const CHANGE_LOG_TITLE = /^(Updated|Created|Deleted)\b/;

export function isChangeOrUpdateLogTitle(title) {
  return CHANGE_LOG_TITLE.test(title || "");
}

export function isHiddenActivityLogTitle(title) {
  if (!title) return false;
  if (isChangeOrUpdateLogTitle(title)) return false;
  if (ACTIVITY_LOG_KEEP_GET_TITLES.includes(title)) return false;
  return /^Get /.test(title);
}

export function activityLogSearchQuery(entityId, commentOnly = false) {
  if (commentOnly) {
    return { entityId, type: "COMMENT" };
  }

  return {
    entityId,
    $or: [
      { title: { $regex: CHANGE_LOG_TITLE.source } },
      { type: "COMMENT" },
      { title: { $in: ACTIVITY_LOG_KEEP_GET_TITLES } },
      { title: { $not: { $regex: "^Get " } } },
    ],
  };
}
